import { Language } from '../../types/language'

export type AboutCopy = {
  heading: string
  teaser: string[]
  expanded: string[]
  readMore: string
  readLess: string
  quote: string
  icfBadge: string
  icfPrefix: string
  icfLinkText: string
  icfSuffix: string
  portraitAlt: string
}

export const aboutCopy: Record<Language, AboutCopy> = {
  nl: {
    heading: 'Over mij: geworteld in verbinding',
    teaser: [
      'Ik begon mijn carrière als engineer, gedreven door nieuwsgierigheid, structuur en het oplossen van problemen. In de jaren daarna ontwikkelde mijn pad zich via rollen in sales, business development, supply chain en leiderschap.',
      'Onderweg leerde ik dat werk en leven diep met elkaar verbonden zijn. De momenten waarop ik me het sterkst voelde in mijn werk, waren vaak de momenten waarop mijn leven daarbuiten ook in balans was. Vrienden, familie, de natuur en mijn hond Django zijn altijd een belangrijk fundament voor me geweest, zowel in uitdagende als in succesvolle periodes.',
    ],
    expanded: [
      'Toen mijn verantwoordelijkheden groeiden, groeiden ook de keuzes, de verwachtingen en de druk die daarbij hoorde. Coaching gaf me meer vertrouwen in de beslissingen die ik als leidinggevende moest nemen, en hielp me tegelijkertijd meer betekenis en richting te vinden in werk én leven.',
      'Ik geloof dat antwoorden uit veel richtingen kunnen komen: stilteretraites, ademoefeningen, betekenisvolle gesprekken of simpelweg tijd in de natuur. Maar de krachtigste inzichten vond ik door coaching. Niet omdat iemand mij de antwoorden gaf, maar omdat coaching me hielp genoeg te vertragen om mijn eigen antwoorden echt te horen.',
      'Die ervaring zorgde ervoor dat ik verliefd werd op coaching, en op anderen helpen om diezelfde helderheid en hetzelfde zelfvertrouwen te vinden.',
      'Inmiddels bouw ik aan MarkV Coaching en ontwikkel ik mijn coachingexpertise verder via de International Coaching Federation (ICF). Met mijn eigen coachingmodel in vier stappen help ik mensen afstand te nemen van de druk van het dagelijks leven, de regie over hun keuzes terug te pakken en een richting te creëren die echt van hen is.',
    ],
    readMore: 'Lees mijn hele verhaal',
    readLess: 'Lees minder',
    quote:
      'De veiligste route naar beneden is vaak die iedereen al genomen heeft. De meest betekenisvolle en effectieve paden maak je zelf.',
    icfBadge: 'ACC-accreditatie in voorbereiding',
    icfPrefix: 'Ik werk volgens de ',
    icfLinkText: 'ICF-kerncompetenties',
    icfSuffix: ' en de ICF-ethische code.',
    portraitAlt: 'Mark Vermeulen',
  },
  en: {
    heading: 'About me: grounded in connection',
    teaser: [
      'I started my career as an engineer, driven by curiosity, structure, and problem-solving. Over the years, my path evolved through roles in sales, business development, supply chain, and leadership.',
      'Along the way, I learned that work and life are deeply connected. The moments where I felt strongest at work were often the moments where life outside of work was in balance too. Friends, family, nature, and my dog Django have always been an important foundation for me, in both challenging and successful periods.',
    ],
    expanded: [
      'As my responsibilities grew, so did the choices, the expectations, and the pressure that came with them. Coaching gave me more confidence in the decisions I had to make as a leader, while also helping me find more meaning and direction in both work and life.',
      'I believe answers can come from many directions: silent retreats, breathing exercises, meaningful conversations, or simply time in nature. But the most powerful insights I found came through coaching. Not because someone gave me the answers, but because coaching helped me slow down enough to truly hear my own.',
      'That experience made me fall in love with coaching, and with helping others find that same clarity and confidence.',
      'Today I am building MarkV Coaching and further developing my coaching expertise through the International Coaching Federation (ICF). Using my own four-step coaching model, I help people step back from the pressure of daily life, regain ownership of their choices, and create a direction that is truly their own.',
    ],
    readMore: 'Read my full story',
    readLess: 'Read less',
    quote:
      'The safest route down is often the one everyone has already taken. The most meaningful and effective paths are the ones you create yourself.',
    icfBadge: 'ACC credential in preparation',
    icfPrefix: 'I work according to the ',
    icfLinkText: 'ICF Core Competencies',
    icfSuffix: ' and the ICF Code of Ethics.',
    portraitAlt: 'Mark Vermeulen',
  },
}
